import React from 'react';
import PropTypes from 'prop-types';

class PlaceholderDisplay extends React.PureComponent {
    static propTypes = {
        model: PropTypes.object.isRequired,
        reportReady: PropTypes.func,
    };

    static defaultProps = {
        reportReady: () => undefined,
    };

    componentDidMount() {
        this.props.reportReady(true);
    }

    render() {
        const { isMainMedia, width, height } = this.props.model;
        const globalClass = isMainMedia ? 'main-media qti-embed-placeholder' : 'qti-embed-placeholder';
        const style = {};

        if (width > 0) {
            style.width = `${width}px`;
        }
        if (height > 0) {
            style.height = `${height}px`;
        }

        return <div className={globalClass} style={style} />;
    }
}

export default PlaceholderDisplay;
